module.exports = __webpack_public_path__ + "static/media/YF35_2.5412acfb.jpg";